module.exports = __webpack_public_path__ + "img/Svalbard & Jan Mayen Islands.b1ef4ed0.svg";